import { memo, ReactNode, useCallback, useTransition } from "react";

type Props = {
  transitional: () => void | Promise<void>;
  children: (handleClick: () => void, isPending: boolean) => ReactNode;
};

const ReactiveToggle = ({ transitional, children }: Props) => {
  const [isPending, startTransition] = useTransition();

  const handleClick = useCallback(() => {
    startTransition(() => {
      void transitional();
    });
  }, [transitional]);

  return children(handleClick, isPending);
};

export default memo(ReactiveToggle);
